'use client'
import Header from "../Header";
import useMount from "react-use/lib/useMount";
import styles from '../sales.module.css';
import logPageView from "lib/ga/pageView";
import useAsyncFn from "react-use/lib/useAsyncFn";
import axios from "axios";
import TextField from '@mui/material/TextField';
import useReducer, { ReducerProvider } from "./reducer";
import logEvent from "lib/ga/miscEvent";
import { useEffect, useRef, useState } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const ContactPage = () => {
    const [{ contactForm }, dispatch] = useReducer();
    const ref = useRef<HTMLDivElement>(null);
    let [errorMessage, setErrorMessage] = useState<string | string[]>('');
    let [successMessage, setSuccessMessage] = useState(false);
    let [formSent, setFormSent] = useState(false);

    const scrollToElement = () => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        scrollToElement();
    }, []);

    const validationChecksMeth = (data) => {
        let errors: string[] = [];
        let mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let textErrors = {
            name: "name",
            email: "email",
            phone: "phone",
            company: "company",
            message: "message",
            reason: "reason for contacting"
        }

        Object.keys(data).forEach((item) => {
            if (data[item] === '') {
                errors.push(`You have entered a invalid ${textErrors[item]}`)
            } else if (data[item].length < 2) {
                errors.push(`You have entered a invalid ${textErrors[item]}`)
            } else if(item === 'email' && !data[item].match(mailformat)) {
                errors.push('You have entered a invalid email address.')
            } else if(item === 'phone' && data[item].length < 7) {
                errors.push("You have entered a invalid phone number.")
            }
        })

        if (errors.length > 0) {
            setErrorMessage(errors)

            return false
        }
        return true;
    }

    const [mailState, sendMail] = useAsyncFn(async () => {
        setFormSent(true);
        setErrorMessage('');

        if (!validationChecksMeth(contactForm.inputs)) {
            setFormSent(false);
            return 'bad'
        }
        try {
            const { data, status } = await axios.post(
                `${process.env.NEXT_PUBLIC_APP_URL}/api/mail/contactUs`,
                {
                    ...contactForm.inputs,
                    agent: '128599',
                    url: window.location.href,
                },
                {
                    headers: {
                        accept: "application/json",
                        "content-type": "application/json",
                    },
                }
            );
            if (Math.floor(status / 100) === 2) {
                setSuccessMessage(true)
                logEvent({
                    category: "Contact us",
                    action: "Contact us form submit",
                    label: contactForm.inputs.reason,
                });
                dispatch({ type: "contactFormReset" });
                setFormSent(false);
                return data;
            } else {
                setErrorMessage("We couldn't send your message right now. Please try again in a minute.");
                setFormSent(false);
                return "BAD";
            }
        } catch (error) {
            setErrorMessage("We couldn't send your message right now. Please try again in a minute.");
            setFormSent(false);
            return "BAD";
        }
    }, [contactForm]);

    useMount(() => {
        logPageView({ url: window.location.pathname + window.location.search });
    });

    return <>
        {/* <Header active={'contact'} pageTitle={'Contact Us'} /> */}
        <div className={`${styles.AgentContainer} ${styles.contact}`} ref={ref}>
            <h1>Get in touch</h1>
            <p><PhoneIcon />01483 238920</p>
            {/* <p><LocationOnIcon />Completely Retail, 51-53 High Street, Guildford, Surrey, GU1 3DY</p> */}
            {successMessage && (
                <div>
                    <CheckCircleOutlineIcon sx={{ fontSize: '50px', color: '#941E3A', marginBottom: '10px' }} />
                    <h2>Thank you for getting in touch!</h2>
                    <p>We appreciate you contacting us. One of our colleagues will get back in touch soon.</p>
                </div>
            )}

            {!successMessage && (
                <form className={styles.contactForm2}>
                    <TextField value={contactForm.inputs.name} className={styles.input} required id="name" label="Name" variant="outlined" onChange={(e) => {
                        dispatch({ type: "contactFormInput", payload: { name: e.currentTarget.value } });
                    }} />
                    <TextField value={contactForm.inputs.company} required className={styles.input} id="Company" label="Company" variant="outlined" onChange={(e) => {
                        dispatch({ type: "contactFormInput", payload: { company: e.currentTarget.value } });
                    }} />
                    <TextField value={contactForm.inputs.email} required className={styles.input}id="Email" label="Email" variant="outlined" onChange={(e) => {
                        dispatch({ type: "contactFormInput", payload: { email: e.currentTarget.value } });
                    }} />
                    <TextField value={contactForm.inputs.phone} required className={styles.input} id="Phone" label="Phone" variant="outlined" onChange={(e) => {
                        dispatch({ type: "contactFormInput", payload: { phone: e.currentTarget.value } });
                    }} />

                    <TextField value={contactForm.inputs.message} required className={styles.input}id="Message" label="Message" multiline
                        rows={5} variant="outlined" onChange={(e) => {
                            dispatch({ type: "contactFormInput", payload: { message: e.currentTarget.value } });
                        }} />
                    {errorMessage && (
                        <div className={styles.errorContanier}>
                            {Array.isArray(errorMessage) && (
                                    <ul>
                                        {errorMessage.map((message, index) => {
                                            return <li key={index}>{message}</li>;
                                        })}
                                    </ul>
                            )}

                            {
                                !Array.isArray(errorMessage) && (
                                    <>{errorMessage}</>
                                )
                            }
                        </div>
                    )}
                    <div className={styles.contactButtonContainer}>
                        <button type="button" className={styles.contactButton} disabled={formSent} onClick={(e) => { e.preventDefault; sendMail(); }} >Submit</button>
                    </div>
                </form>
            )
            }
        </div>
    </>

};

const ContactUs = (props) => {
    return (
        <ReducerProvider>
            <ContactPage />
        </ReducerProvider>
    );
};

export default ContactUs;
